import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <p>© 2024 Sci-Fi Movie Showcase. All Rights Reserved.</p>
        </footer>
    );
};

export default Footer;
